import { render } from "./ButtonsGroup.vue?vue&type=template&id=0e4c6399&ts=true"
import script from "./ButtonsGroup.vue?vue&type=script&lang=ts"
export * from "./ButtonsGroup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__